import IconArCube3 from "@ui/central-icons/icons/IconArCube3";
import IconBfl from "@ui/central-icons/icons/IconBfl";
import IconBiRefNet from "@ui/central-icons/icons/IconBiRefNet";
import IconBytedance from "@ui/central-icons/icons/IconBytedance";
import IconCreatify from "@ui/central-icons/icons/IconCreatify";
import IconGoogle from "@ui/central-icons/icons/IconGoogle";
import IconKling from "@ui/central-icons/icons/IconKling";
import IconLtx from "@ui/central-icons/icons/IconLtx";
import IconOpenai from "@ui/central-icons/icons/IconOpenai";
import IconSyncLipsync from "@ui/central-icons/icons/IconSyncLipsync";
import IconTopaz from "@ui/central-icons/icons/IconTopaz";
import { iconStrokeFix } from "@ui/central-icons/iconUtils";
import type { GenerationModel } from "./types";

export const MODEL_ICONS: Record<GenerationModel, React.ComponentType<{ className?: string }>> = {
  "gemini-2.5-flash-image": IconGoogle,
  "gemini-3.1-flash-image-preview": IconGoogle,
  "gemini-3-pro-image-preview": IconGoogle,
  "gpt-image-2": IconOpenai,
  "veo-3.1-generate-001": IconGoogle,
  "veo-3.1-fast-generate-001": IconGoogle,
  "kling-3-pro": IconKling,
  "kling-omni-edit-video": IconKling,
  "topaz-image-upscale": IconTopaz,
  "topaz-video-upscale": IconTopaz,
  "ltx-v2-retake": IconLtx,
  "creatify-aurora": IconCreatify,
  "flux-1-kontext": IconBfl,
  "flux-2-pro": IconBfl,
  "bytedance-seedance-v2": IconBytedance,
  "sync-lipsync-v2-pro": IconSyncLipsync,
  "birefnet-v2-bg-removal": IconBiRefNet,
};

export function ModelIcon({ generationModel, className }: { generationModel: GenerationModel; className?: string }) {
  const Icon = MODEL_ICONS[generationModel] ?? IconArCube3;
  return <Icon className={className} />;
}

export function ModelBadge({
  generationModel,
  modelDisplayName,
}: {
  generationModel: GenerationModel;
  modelDisplayName: string;
}) {
  return (
    <div className='tw-flex tw-items-center tw-gap-1 tw-rounded-md tw-px-1.5 tw-py-1.5 tw-opacity-60'>
      <ModelIcon generationModel={generationModel} className={`${iconStrokeFix} tw-size-5 tw-shrink-0 tw-text-black`} />
      <span className='tw-font-display tw-text-[14px] tw-leading-none tw-text-black'>{modelDisplayName}</span>
    </div>
  );
}
